import { Component, OnInit, ViewChild } from '@angular/core';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { CredentialRenovation } from '@asambleas-models/CredentialRenovation';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { GeneralService } from '@asambleas-services/general/general.service';
import { Router } from '@angular/router';
import { LoginService } from '@asambleas-services/login/login.service';
import { ConfirmComponent } from '@asambleas-components/confirm/confirm.component';
import { CredentialRenovationsService } from '@asambleas-services/credential-renovations.service';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

@Component({
  selector: 'app-requests-credential-renovation',
  templateUrl: './requests-credential-renovation.component.html',
  styleUrls: ['./requests-credential-renovation.component.scss']
})
export class RequestsCredentialRenovationComponent implements OnInit {

  renovationCredentialRequests: CredentialRenovation[] = [];

  displayedColumns: string[] = ['nombre', 'fecha', 'estado', 'correo', 'ver', 'paso-produccion'];
  dataSource = new MatTableDataSource<CredentialRenovation>(this.renovationCredentialRequests);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private ministerService: MinisterService,
    private loadService: LoadService,
    private loginService: LoginService,
    private userFeedback: UserFeedbackService,
    private dialog: MatDialog,
    public generalService: GeneralService,
    private _credentialRenovationsService: CredentialRenovationsService,
    private router: Router) { }

  ngOnInit() {

    this.getRenovationCredentialRequests();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getRenovationCredentialRequests() {
    let loader = this.loadService.createLoad('');
    loader.open();

    this.ministerService.getRenovationCredentialRequests()
      .subscribe((data: CredentialRenovation[]) => {

        this.renovationCredentialRequests = data.filter((credentialRequest) => {
          return credentialRequest.minister.user.id != this.loginService.getUser().id;
        })
        this.dataSource.data = this.renovationCredentialRequests;

        console.log(this.dataSource.data);

        loader.close();
      }, (error) => {
        console.log('Hubo un error', error);
        loader.close();
      })
  }

  seeRequest(request: CredentialRenovation) {
    if (request.status == '01') {  // SI TIENE EL ESTADO ENVIADA

      this.ministerService.setCredentialRequestStatus(request.id, { status: '02' })
        .subscribe((data) => {
          console.log(data);
        }, (error) => {
          console.log('Hubo un error', error);
        })
    }

    this.router.navigate(['/admin', 'ministers', 'request-credential-renovation', request.id]);
  }

  toProduction(credentialRenovation: CredentialRenovation) {
    const ref = this.dialog.open(ConfirmComponent, {
      data: { title: 'Paso a producción', content: '¿Está seguro de pasar a producción la solicitud?', btnAgree: 'Aprobar', btnDisagree: 'Cancelar' }
    });

    ref.afterClosed()
      .subscribe((data: { return: boolean }) => {

        if (data.return) {
          this._credentialRenovationsService.toProduction({ id: credentialRenovation.id })
            .subscribe((response) => {

              this.userFeedback.openSnackbar({ message: 'Paso a producción realizado exitósamente' });

              this.dataSource.data = [];
              this.getRenovationCredentialRequests();
            })
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/requests-credential-renovation/requests-credential-renovation.component.ts